module.exports = __webpack_public_path__ + "img/eforms.87590ab7.png";